import { render, staticRenderFns } from "./StatisticsInfo.vue?vue&type=template&id=6ff80f24&scoped=true"
import script from "./StatisticsInfo.vue?vue&type=script&lang=js"
export * from "./StatisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./StatisticsInfo.vue?vue&type=style&index=0&id=6ff80f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff80f24",
  null
  
)

export default component.exports